const SET_ABILITY_GROUPS = (state, abilityGroups) => {
  state.abilityGroups = abilityGroups
}
const SET_ACCOUNT = (state, account) => {
  state.account = account
}

const SET_LOGGED_IN = (state, status) => {
  state.loggedIn = status
}

const SET_USER = (state, user) => {
  state.user = user
}

const SET_LOGIN_ERROR = (state, errorMessage) => {
  state.loginError = errorMessage
}

const SET_NUMBERS = (state, numbers) => {
  state.numbers = numbers
}

const SET_ROLES = (state, roles) => {
  state.roles = roles
}

const ADD_NOTIFICATION = (state, notification) => {
  state.notifications.push(notification)
}

const REMOVE_NOTIFICATION = (state, index) => {
  state.notifications.splice(index, 1)
}

const CLEAR_NOTIFICATIONS = (state) => {
  state.notifications = []
}

export default {
  SET_ABILITY_GROUPS,
  SET_ACCOUNT,
  SET_LOGGED_IN,
  SET_LOGIN_ERROR,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  SET_NUMBERS,
  SET_ROLES,
  SET_USER
}
